import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { fmtEUR, fmtDate } from "../../lib/format";
import { Button } from "../ui/button";
import { toast } from "sonner";

export default function AccontiSuggeriti({ invoice, onDone }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setRows([]); if (invoice?.id && invoice.tipo === "passiva") api.get(`/invoices/${invoice.id}/acconti-suggeriti`).then((r) => setRows(r.data)).catch(() => {}); }, [invoice?.id]);
  if (!rows.length) return null;
  const chiudi = async (r) => {
    setBusy(true);
    try { const { data } = await api.post(`/invoices/${invoice.id}/chiudi-con-acconto`, { movement_id: r.id }); toast.success(`Fattura chiusa con l'acconto del ${fmtDate(r.data)}: usati ${fmtEUR(data.usato)}${data.eccedenza ? `, restano ${fmtEUR(data.eccedenza)} di acconto aperto` : ""}${data.residuo_fattura > 0 ? ` · residuo fattura ${fmtEUR(data.residuo_fattura)}` : ""}`); onDone(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 p-2 text-xs space-y-1" data-testid="acconti-suggeriti">
      <div className="font-semibold text-amber-800">Acconti già pagati a questo fornitore (fattura in arrivo)</div>
      <div className="text-amber-700">Usa l'acconto come pagamento: nessun nuovo movimento in prima nota, niente costo doppio.</div>
      {rows.map((r) => (
        <div key={r.id} className="flex items-center justify-between gap-2 border-t border-amber-200 pt-1" data-testid="acconto-suggerito">
          <div>{r.esatto ? "★ " : ""}{fmtDate(r.data)} · <b>{fmtEUR(r.importo)}</b>{r.ordine ? ` · ordine ${r.ordine}` : ""}{r.operazione ? ` · ${r.operazione}` : ""}{r.in_ritardo ? <span className="text-destructive"> · fattura in ritardo</span> : null}</div>
          <Button size="sm" variant={r.esatto ? "default" : "outline"} className="h-7" onClick={() => chiudi(r)} disabled={busy} data-testid="acconto-chiudi-btn">Chiudi con questo acconto</Button>
        </div>))}
    </div>
  );
}
